import React from 'react';

import Zoom from 'assets/images/icon/Zoom';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { textTransform } from 'util/textTransform';
import DeleteIcon from "../../../../assets/images/icon/DeleteIcon";
import ClockIcon from "../../../../assets/images/icon/ClockIcon";
import TrashCanDark from "../../../../assets/images/icon/TrashCanDark";
import {isEmpty} from "../../../../util";

const returnColor = (text) => {
    switch (text) {
        case "New": {
            return "#FFC8DD";
        }
        case "IN_PROGRESS": {
            return "#9AE3B7";
        }
        case "COMPLETED": {
            return "rgba(154, 227, 183, 1)";
        }
        case "REJECTED": {
            return "rgba(242, 132, 132, 1)";
        }
        case "PUBLISHED":{
            return "#B0CBFF"
        }
        default:
            break;
    }
};
const CompletedListItem = (props) => {
    const navigate = useNavigate();

    const onClickEdit = (progress) => {
        switch (progress){
            case "DRAFT" : {
                return {
                    icon:<TrashCanDark/>,
                    event:() => {props?.onClickIcon(props?.data?.id)}
                }
            }
            case "IN_PROGRESS"  : {
                return {
                    icon:<ClockIcon/>,
                    event:() => {
                        props?.onClickSelect(props?.data)
                        props?.onClickTimePopup();
                    }
                }
            }
            case "PUBLISHED" : {
                return {
                    icon:<ClockIcon/>,
                    event:() => {
                        props?.onClickSelect(props?.data)
                        props?.onClickTimePopup();
                    }
                }
            }
            default : {
                return {
                    icon:<></>,
                    event:() => {}
                }
            }
        }
    }
    const returnData = (date) => {
        // const c = cloneDeep(date)?.map((item, index) => {
        //     if (index === 1) {
        //         item = item - 1;
        //     }
        //     return item;
        // });
        // let ms = dayjs(Date.UTC.apply(null, c?.slice(0, 6)))
        //     .utc()
        //     .locale("en")
        //     .format("MMM DD, YYYY");
        return date;
    };

    const checkTimeAway = () => {
        if(isEmpty(props?.data?.coachingTypes)) return false
        const c = cloneDeep(props?.data);
        const check = c?.coachingTypes?.findIndex(item => {
            return item?.timeAway === true
        })

        if(check !== -1){
            return true
        }else{
            return false
        }
    }
    console.log('listData', props?.data)
    // @ts-ignore
    return (
        <Container>
            <Thumb>
                <img src={props?.data?.thumbnail?.url ?? "/images/homeworkImg.png"} alt="" />
                {/*<EditIcon className={"edit"}*/}
                {/*    onClick={()=>{*/}
                {/*        onClickEdit(String(props?.data?.progress))?.event()*/}
                {/*    }}*/}
                {/*>*/}
                {/*    {onClickEdit(String(props?.data?.progress))?.icon}*/}
                {/*</EditIcon>*/}

            </Thumb>
            <ListMain>
                <CategoryList>
                    <Category
                        style={{
                            background: returnColor(String(props?.data?.coachingApplication?.coachingStatus)),
                        }}
                    >
                        <span>{textTransform().capitalizeFirstLetter(String(props?.data?.coachingApplication?.coachingStatus)?.toLocaleLowerCase()) === "In_progress" ? "Submitted" :
                            textTransform().capitalizeFirstLetter(String(props?.data?.coachingApplication?.coachingStatus)?.toLocaleLowerCase())}</span>
                    </Category>
                </CategoryList>
                <p
                    className={"subTitle"}
                    style={{
                        marginBottom: 10,
                    }}
                >How to develop your potential</p>
                <h3>
                    {/*{props?.data?.title}*/}
                    {/*{props?.data?.coachingTitle}*/}
                    {props?.data?.coachingApplication?.liveCoaching?.title}
                </h3>
                <DateItem style={{marginBottom: 0}}>
                    <p>
                        {/*{returnData(props?.data?.updatedDatetime)}*/}
                        Feb 11, 2024
                    </p>
                </DateItem>
                <span
                style={{marginTop:2}}
                >{props?.data?.teacherName}</span>
            </ListMain>
            <ListButton onClick={() => {
                props.onClickGetData(props?.data)

            }}>
                <span>{props?.data?.progress !== "DRAFT" ? "Edit" : "Edit"}</span>
                {props?.data?.progress !== "DRAFT" ? (
                    <Zoom />
                ) : (
                    <img src={"/images/pen.png"} alt="" />
                )}
            </ListButton>
        </Container>
    );
};
export default CompletedListItem;

const ContentsInner = styled.div`
    padding: 20px;
    overflow: hidden;
`;

const Wrap = styled.div`
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const Container = styled.div`
    display: flex;
    position: relative;
    padding: 20px 0;
    border-top: 1px solid rgba(51, 51, 51, 0.3);
    .edit{
        transition: all 0.2s;
        opacity: 0;
        pointer-events: none;
    }
    &:hover{
        .edit{
            opacity: 1;
            pointer-events: all;
        }
    }
`;
const Thumb = styled.div`
    transition: all 0.2s;
    background: #ddd;
    width: 113px;
    height: 122px;
    border-radius: 5px;
    position: relative;
    img {
        display: block;
        border-radius: 5px;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

`;
const EditIcon = styled.div`
   left: 0;
   top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    svg{
        pointer-events: none;
    }
    cursor: pointer;
    width: 30px;
    height: 30px;
    transform: translate(-25%, -25%);
    border-radius: 50%;
    background: #fff;
   position: absolute;
    box-shadow: -1px 1px 4px 0px #3333331F;
`
const ClassInfo = styled.div`
    position: absolute;
    border-radius: 0 0 5px 5px;
    z-index: 9;
    width: 100%;
    padding-top: 7px;
    padding-bottom: 6px;
    display: flex;
    justify-content: center;
    background: #333;
    left: 0;
    bottom: 0;
    span{
        font-family: Europa-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
        letter-spacing: 0em;
        text-align: left;
        color: #fff;
    }
`
const ListMain = styled.div`
    padding: 0 20px;
    flex: 1;
    display: flex;
    height: 122px;
    flex-direction: column;
    justify-content: space-between;

    border: solid 1px #333;
    &:hover{
        background: #fff;
        span{
            color: #333;
        }
        svg{
            display: block;
            path{
                fill: #333;
            }
        }
    }
    svg{
        display: block;
        path{
            fill: #fff;
        }
    }
    .subTitle{
        margin-top: 4px;
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        color: rgba(51, 51, 51, 0.8);
        margin-bottom: 15px;
    }
    h3 {
        font-size: 26px;
        margin-bottom: 4px;
    }
    & > span{
        font-family: Europa-Bold;
        font-size: 16px;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        color: rgba(51, 51, 51, 0.8);
    }
`;
const CategoryList = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    p{
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        color:rgba(51, 51, 51, 0.8);
    }
`;
const Category = styled.div`
    padding: 7px 12px;
    margin-right: 15px;
    background: #f0a8a8;
    cursor: default;
    width: 85px;
    font-size: 12px;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-bottom: 4px;
    font-weight: 700;
    span {
        text-transform: capitalize;
    }
`;
const DateItem = styled.div`
    display: flex;
    p {
        color: #33333385;
    }
    span {
        font-size: 14px;
        font-weight: 600;
        line-height: 14px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333ac;
    }
`;

const Progress = styled.div`
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0em;
    color: rgba(51, 51, 51, 0.6);
    text-align: end;
    margin-bottom: 0.25rem;
    max-width: 500px;
    b {
        color: #333;
    }
`;
const ProgressBar = styled.div``;
const ListButton = styled.div`
    background: #333;
    width: 87px;
    height: 30px;
    border-radius: 5px;
    overflow: hidden;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    span {
        padding-top: 2px;
        margin-right: 10px;
        display: flex;
        height: 100%;
        align-items: center;
        color: #fff;
        box-shadow: none;
        border-radius: 5px;
        font-family: var(--fontFamilyRegular);
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
    }
`;

const Instructor = styled.div`
    margin-left: 20px;
`;
const User = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: #333333d2;
`;
